// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getAuth, RecaptchaVerifier, signInWithPhoneNumber } from 'firebase/auth';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

// const firebaseConfig = {
//   apiKey: 'AIzaSyBnOYu_u3RlyHnzDC5J9MnsrVeS4YOU3aI',
//   authDomain: 'vavaclasses.com',
//   projectId: 'vavaclasses',
//   storageBucket: 'vavaclasses.appspot.com',
//   messagingSenderId: '564200417674',
//   appId: '1:564200417674:web:34664a7990d0f355e5c073',
//   measurementId: 'G-511PS37CEV'
// };

const firebaseConfig = {
  apiKey: 'AIzaSyBJxWC_yS3nBMeD_dyYDln4lqWU766L7QQ',
  authDomain: 'treatu-382218.firebaseapp.com',
  projectId: 'treatu-382218',
  storageBucket: 'treatu-382218.appspot.com',
  messagingSenderId: '756887168652',
  appId: '1:756887168652:web:313bcf6c26c664dcd93da9',
  measurementId: 'G-5NT7YPE120'
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);

class FBOTPHandler {
  constructor(auth) {
    this.auth = auth;
    this.appVerifier = null;
    this.confirmationResult = null;
  }

  getAppVerifier({cb, expCb, captchaElementOrID, sameCaptchaElement}) {
    if (sameCaptchaElement && this.appVerifier) { return this.appVerifier; }
    try {
      const onSuccess = () => {
        if (cb) {
          cb();
        }
        console.log('Captcha success');
      };
      const onExpired = () => {
        if (expCb) {
          expCb();
        }
        console.log('Captcha Expired');
      };
      const options = {
          size: 'invisible',
          callback: onSuccess,
          'expired-callback': onExpired,
      };
      this.appVerifier = new RecaptchaVerifier(captchaElementOrID, options, this.auth );
      return this.appVerifier;
    } catch (error) {
      console.log({error});
      return null;
    }
  }

  async sendFbOtp({phoneNumber, captchaElementOrID, sameCaptchaElement = false}) {
    const appVerifier = this.getAppVerifier({captchaElementOrID, sameCaptchaElement});
    if (!appVerifier) return { err: 'App Verifier Issue', res: null };
    const {err, res} = await signInWithPhoneNumber(auth, phoneNumber, appVerifier)
      .then((confirmationResult) => {
        // SMS sent. Prompt user to enter the code.
        this.confirmationResult = confirmationResult;
        return { err: null, res: confirmationResult };
      }).catch((error) => {
        // Handle Errors here.
        console.error('Error during signInWithPhoneNumber', error);
        return { err: error, res: null };
      });
    return { err, res };
  }

  async verifyFbOtp({otp}) {
    const {err, res} = await this.confirmationResult.confirm(otp)
      .then((result) => {
        // const user = result.user;
        // console.log("User  signed in:", user);
        console.log('OTP verification success');
        return { err: null, res: result };
      }).catch((error) => {
        console.error('Error verifying OTP');
        console.log({error});
        return { err: error, res: null };
      });
     return { err, res };
  }
}

export const fbOtpHandler = new FBOTPHandler(auth);
